import { useEffect, useState } from "react";
import { AgoraRTCError, AgoraRTCErrorCode, createScreenVideoTrack, IAgoraRTCClient, ILocalAudioTrack, ILocalVideoTrack, ScreenVideoTrackInitConfig } from "agora-rtc-react";

interface IShareScreenProps {
    publish: (track: ILocalVideoTrack) => void,
    unpublish: (track: ILocalVideoTrack) => void
}

const config: ScreenVideoTrackInitConfig = {
    screenSourceType: "screen",
    encoderConfig: "720p_2",
    optimizationMode: "detail"
}

const getScreenSharingVideoTrack = (tracks: ILocalVideoTrack | [ILocalVideoTrack, ILocalAudioTrack]) => {
    if (Array.isArray(tracks)) {
        return tracks[0]
    } else {
        return tracks
    }
}

const ShareScreen = (props: IShareScreenProps) => {
    const useScreenSharingTrack = createScreenVideoTrack(config, "disable");
    const { tracks, error } = useScreenSharingTrack();
    const [hasPublished, setHasPublished] = useState(false);

    useEffect(() => {
        if(hasPublished || !tracks) return;

        const track = getScreenSharingVideoTrack(tracks);
        props.publish(track);
        setHasPublished(true);
        
        return () => {
            unpublish();
        }
    }, [tracks]);

    useEffect(() => {
        if(error)
            handleError(error);
    }, [error]);

    const handleError = (err: AgoraRTCError) => {
        console.error("Agora error");
        if(!err?.code) return;
        switch(err.code)
        {
            case AgoraRTCErrorCode.PERMISSION_DENIED:
                console.warn("Invalid operation", err);
                unpublish();
                break;
            default:
                console.warn("Error screen track", err);
                break;
        }
    }

    const unpublish = () => {
        const track = getScreenSharingVideoTrack(tracks);
        props.unpublish(track);
    }
    
    return (
        <>Screen sharing</>
    )
}

export default ShareScreen;
